/**
 * 数字入力の桁区切り(2026-09-10 指示: 入力途中から「,」が入るように)。
 * 画面に出すのは区切り付き、保存・計算に使うのは区切り無しの文字列に分ける。
 */

/** 全角数字・全角記号を半角にする(貼り付け対策) */
function toHalf(s: string): string {
  return s.replace(/[０-９．，－−ー]/g, (ch) => {
    if (ch >= '０' && ch <= '９') return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
    if (ch === '．') return '.';
    if (ch === '，') return ',';
    return '-';
  });
}

/** 表示用の文字列 → 保存用(数字・マイナス・小数点だけ) */
export function stripNum(s: string, decimal = false): string {
  const t = toHalf(s);
  const neg = t.trim().startsWith('-');
  const body = t.replace(decimal ? /[^0-9.]/g : /[^0-9]/g, '');
  // 小数点は最初の1つだけ残す
  const dot = decimal ? body.indexOf('.') : -1;
  const one = dot < 0 ? body : body.slice(0, dot + 1) + body.slice(dot + 1).replace(/\./g, '');
  return (neg ? '-' : '') + one;
}

/** 保存用の文字列 → 表示用(3桁ごとに「,」。入力途中の「-」「12.」もそのまま返す) */
export function formatNum(s: string, decimal = false): string {
  const raw = stripNum(s, decimal);
  if (raw === '' || raw === '-') return raw;
  const neg = raw.startsWith('-');
  const body = neg ? raw.slice(1) : raw;
  const dot = body.indexOf('.');
  const int = dot < 0 ? body : body.slice(0, dot);
  const rest = dot < 0 ? '' : body.slice(dot);
  const grouped = int === '' ? '' : Number(int).toLocaleString('en-US');
  return `${neg ? '-' : ''}${grouped}${rest}`;
}
